interface FavoriteButtonProps {
  active: boolean;
  onToggle: () => void;
  className?: string;
}

export default function FavoriteButton({ active, onToggle, className = "" }: FavoriteButtonProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs transition ${
        active
          ? "bg-accent-500 text-background-50 hover:bg-accent-600"
          : "bg-background-100 text-foreground-600 hover:bg-accent-100 hover:text-accent-800"
      } ${className}`}
    >
      <i className={active ? "ri-bookmark-fill" : "ri-bookmark-line"}></i>
      {active ? "已收藏" : "收藏"}
    </button>
  );
}